import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Plus, Merge } from "lucide-react";

import { auth } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from "../../components/ui/sidebar";

import ProjectJoinModal from "../Projects/ProjectJoin";

const HomeSidebar = () => {
  const [canCreateProject, setCanCreateProject] = useState(false);
  const [projectJoinModalOpen, setProjectJoinModalOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const checkUserRole = async (user) => {
      try {
        // Get the ID token and decode the custom claims
        const idTokenResult = await user.getIdTokenResult();

        // Check if the user has the 'admin' or 'manager' roles
        if (
          idTokenResult.claims.role === "admin" ||
          idTokenResult.claims.role === "manager"
        ) {
          setCanCreateProject(true);
        }
      } catch (error) {
        console.error("Error checking role:", error);
      }
    };

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        // Force token refresh to retrieve the new custom claims if any
        await firebaseUser.getIdToken(true);

        checkUserRole(firebaseUser);
      } else {
        navigate("/login");
      }
    });

    return () => unsubscribe();
  });

  const openJoinProjectModal = useCallback(() => {
    setProjectJoinModalOpen(true);
  }, []);

  return (
    <>
      <SidebarSeparator className="mt-2" />

      <SidebarGroup>
        <SidebarGroupLabel>Projects</SidebarGroupLabel>

        <SidebarGroupContent>
          <SidebarMenu>
            <Link to={"/projects/add"} state={{ project: null, isNew: true }}>
              <SidebarMenuItem>
                <SidebarMenuButton
                  disabled={!canCreateProject}
                  asChild
                  tooltip="Add project"
                >
                  <div>
                    <Plus />
                    <span>Add project</span>
                  </div>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </Link>

            <div>
              <ProjectJoinModal
                modalOpen={projectJoinModalOpen}
                setModalOpen={setProjectJoinModalOpen}
              />

              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  tooltip="Join project"
                  onClick={openJoinProjectModal}
                >
                  <div>
                    <Merge />
                    <span>Join project</span>
                  </div>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </div>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    </>
  );
};

export default HomeSidebar;
